'use client';
const IDENT = 'RemoveScroll';
const defaultProps = {
    enabled: true,
    removeScrollBar: true
};

export { IDENT, defaultProps };
//# sourceMappingURL=LockScroll.contract.js.map
